import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import ModalForm from "./Modal";
import './customSelectStyles.css';
import LoadDatesForm from './forms/LoadDatesForm';
import app from "../../../libs/apiClient";
import LoadMask from '../Utils/LoadMask';
const service = app.service("api/expenseTicketType");
const ticketService = app.service("api/expenseTicket");
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery';
import { DownloadModal } from "./forms/DownloadModal";
import { RescheduleModal } from "./forms/RescheduleModal";
import FaRouteIcon from "../../icons/fa-route-icon";
import moment from "moment";

const ExpenseTickets = ({ startDate, endDate }) => {

  const [showModal, setShowModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState("");
  const [types, setTypes] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [showDlModal, setShowDlModal] = useState(false);
  const [downloadType, setDownloadType] = useState(null);
  const [ticketToReschedule, setTicketToReschedule] = useState(null);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleSubmit = (formValues) => {
     if (Object.keys(formValues).length > 0) {
        const normalizedValues = { ...formValues };

        if (formValues.startDate) {
           normalizedValues.startDate = moment(formValues.startDate).utc().startOf('day').toISOString();
        }

        if (formValues.endDate) {
           normalizedValues.endDate = moment(formValues.endDate).utc().startOf('day').toISOString();
        }

        console.log('Normalized Values:', normalizedValues);

        getTickets(normalizedValues);
     }
  };

  const handleSelectChange = (expenseType) => {
    if (expenseType) {
      setSelectedExpense(expenseType);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedExpense('')
  };

  const getTypes = async () => {
    const result = await service.find('getTicketHelp')
    setTypes(result)
  }

  const getTickets = async (formValues) => {
    const selectedType = formValues.expense_filter && types.find(item => item.name === 'Toll Expenses');
    try {
      setLoading(true);

      let typeQuery = {};
      if (formValues.expense_filter === 'toll-only' && selectedType) {
        typeQuery = { type: selectedType._id };
      } else if (formValues.expense_filter && selectedType) {
        typeQuery = { type: { $ne: selectedType._id } };
      }

      const result = await ticketService.find({
        query: {
          startDate: formValues.startDate,
          endDate: formValues.endDate,
          ...typeQuery,
          ...(formValues.type && { type: formValues.type })
        }
      });

      if (result) {
        setTickets(result);
        setFilteredTickets(result);
      }
    } catch (error) {
      console.error('Error fetching tickets:', error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTypes()
  }, [])

  useEffect(() => {
    const filtered = tickets.filter((item) => {
      return (
        item.expense_type_id.name.toLowerCase().includes(searchTerm) ||
        item.driver_name.toLowerCase().includes(searchTerm) ||
        item.vehicle_name.toLowerCase().includes(searchTerm) ||
        item.start_datetime.toLowerCase().includes(searchTerm)
      );
    });

    setFilteredTickets(filtered);
  }, [tickets, searchTerm]);

  const rescheduleSuccessAction = () => {
    setTicketToReschedule(null);
    // Refresh tickets after rescheduling
    handleSubmit({ startDate, endDate });
  }

  const showRescheduleButton = (item) => {
     try {
        return item.expense_type_id.name.toLowerCase() === 'service or repair' && item.work_order_id;
     } catch (error) {
        return false;
     }
  };

  return (
    <div className="expense-tickets-container">
      {/* Header Section */}
      <div className="expense-tickets__expense-header">
        <h2 className="expense-tickets__expense-title">Expense Forms</h2>
        <div className="expense-tickets__header-actions">
          <div className="dropdown">
            <button className="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-file-text"></i> Reports
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <div className="dropdown-item" onClick={() => { setDownloadType('compensation'), setShowDlModal(true) }}>
                <i className="fa fa-users"></i> Driver Compensation Report
              </div>
              <div className="dropdown-item" onClick={() => { setDownloadType('tolls'), setShowDlModal(true) }}>
                <i className="fa fa-road"></i> Toll Usage Report
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Controls Section */}
      <div className="expense-tickets__expense-controls">
        {/* Actions Bar */}
        <div className="expense-tickets__actions-bar">
          <div className="dropdown">
            <button
              className="expense-tickets__add-expense-btn dropdown-toggle"
              type="button"
              id="expenseDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {selectedExpense ? selectedExpense : (
                <React.Fragment>
                  <i className="fa fa-plus-circle"></i>
                  Add Expense
                </React.Fragment>
              )}
            </button>
            <div className="dropdown-menu expense-tickets__expense-dropdown-menu" aria-labelledby="expenseDropdown">
              <button className="dropdown-item" onClick={() => handleSelectChange("Backup Driver")}>
                <i className="fa fa-user-plus"></i> Backup Driver
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Breakdown")}>
                <i className="fa fa-wrench"></i> Breakdown
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Car Wash")}>
                <i className="fa fa-tint"></i> Car Wash
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Deadhead")}>
                <FaRouteIcon className={'custom-icon'} size={16} /> Deadhead
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Delayed Passengers")}>
                <i className="fa fa-clock-o"></i> Delayed Passengers
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Delivery")}>
                <i className="fa fa-truck"></i> Delivery
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Downtime")}>
                <i className="fa fa-pause-circle"></i> Downtime
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Employee Pickup")}>
                <i className="fa fa-users"></i> Employee Pickup
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Missed Cancellation")}>
                <i className="fa fa-ban"></i> Missed Cancellation
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Missed Trip")}>
                <i className="fa fa-times-circle"></i> Missed Trip
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Service or Repair")}>
                <i className="fa fa-wrench"></i> Service or Repair
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Training")}>
                <i className="fa fa-graduation-cap"></i> Training
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Vehicle Inspection")}>
                <i className="fa fa-search"></i> Vehicle Inspection
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Vehicle Swap")}>
                <i className="fa fa-exchange"></i> Vehicle Swap
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Toll Expenses")}>
                <i className="fa fa-money"></i> Toll Expenses
              </button>
              <button className="dropdown-item" onClick={() => handleSelectChange("Missed Day")}>
                <i className="fa fa-calendar-times-o"></i> Missed Day
              </button>
            </div>
          </div>

          <div className="expense-tickets__expense-tickets__search-input-wrapper">
            <i className="fa fa-search expense-tickets__search-icon"></i>
            <input
              type="text"
              className="form-control expense-tickets__search-input"
              placeholder="Search by type, driver, vehicle, or date..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>

        {/* Filter Section */}
        <div className="expense-tickets__filter-section">
          <LoadDatesForm onSubmit={handleSubmit} />
        </div>
      </div>

      {/* Tickets List */}
      <div className="expense-tickets__expense-content">
        <LoadMask loading={loading} blur>
          <div className="expense-tickets__tickets-list">
            {filteredTickets.length > 0 ? (
              filteredTickets.map((item) => (
                <div key={item._id} className="expense-tickets__ticket-card">
                  <div className="expense-tickets__ticket-header">
                    <span className="expense-tickets__expense-badge">{item.expense_type_id.name}</span>
                    <div className="expense-tickets__ticket-actions">
                      {/* EDIT BUTTON - Commented out pending proper implementation
                          TODO: Implement edit functionality that:
                          1. Passes the complete ticket item data to the modal
                          2. Pre-fills the form with existing values from 'item'
                          3. Distinguishes between "create" and "edit" mode in the modal
                          4. Updates the existing ticket instead of creating a new one

                          To implement:
                          - Create a new state variable for editingTicket
                          - Modify handleSelectChange to accept ticket data as second parameter
                          - Update ModalForm component to handle edit mode with pre-filled data
                          - Add API call to update existing ticket (ticketService.patch or .update)

                      <button
                        className="expense-tickets__edit-btn"
                        onClick={() => handleSelectChange(item.expense_type_id.name, item)}
                        title="Edit"
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      */}
                      {showRescheduleButton(item) && (
                        <button
                          className="expense-tickets__reschedule-btn"
                          onClick={() => setTicketToReschedule(item)}
                          title="Reschedule"
                        >
                          <i className="fa fa-calendar"></i>
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="expense-tickets__ticket-body">
                    <div className="expense-tickets__ticket-info-grid">
                      <div className="expense-tickets__info-item">
                        <i className="fa fa-calendar-day"></i>
                        <div>
                          <span className="expense-tickets__info-label">Date & Time</span>
                          <span className="expense-tickets__info-value">{item.start_datetime}</span>
                        </div>
                      </div>

                      <div className="expense-tickets__info-item">
                        <i className="fa fa-user"></i>
                        <div>
                          <span className="expense-tickets__info-label">Driver</span>
                          <span className="expense-tickets__info-value">{item.driver_name}</span>
                        </div>
                      </div>

                      <div className="expense-tickets__info-item">
                        <i className="fa fa-id-badge"></i>
                        <div>
                          <span className="expense-tickets__info-label">Driver ID</span>
                          <span className="expense-tickets__info-value">{item.driver_LiveryId || item.driver_fleetioId}</span>
                        </div>
                      </div>

                      <div className="expense-tickets__info-item">
                        <i className="fa fa-car"></i>
                        <div>
                          <span className="expense-tickets__info-label">Vehicle</span>
                          <span className="expense-tickets__info-value">{item.vehicle_name}</span>
                        </div>
                      </div>

                      {item.total_hours != null && (
                        <div className="expense-tickets__info-item">
                          <i className="fa fa-clock"></i>
                          <div>
                            <span className="expense-tickets__info-label">Total Hours</span>
                            <span className="expense-tickets__info-value">{item.total_hours.toFixed(2)}</span>
                          </div>
                        </div>
                      )}

                      <div className="expense-tickets__info-item">
                        <i className="fa fa-hashtag"></i>
                        <div>
                          <span className="expense-tickets__info-label">Livery ID</span>
                          <span className="expense-tickets__info-value">{item.livery_id || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="expense-tickets__no-data">
                <i className="fa fa-inbox fa-3x"></i>
                <p>No expense tickets found</p>
                <span>Try adjusting your filters or search criteria</span>
              </div>
            )}
          </div>
        </LoadMask>
      </div>

      {/* Modals */}
      <ModalForm showModal={showModal} handleCloseModal={handleCloseModal} selectedExpense={selectedExpense} types={types} />

      <DownloadModal
        showModal={showDlModal}
        handleCloseModal={() => { setShowDlModal(false), setDownloadType(null) }}
        type={downloadType}
        options={types.map(item => ({
          value: item.name, label: item.name, id: item._id
        }))}
      />

      <RescheduleModal
        ticketToReschedule={ticketToReschedule}
        handleCloseModal={() => { setTicketToReschedule(null) }}
        rescheduleSuccessAction={rescheduleSuccessAction}
      />
    </div>
  );
};

const loadDatesFormSelector = formValueSelector('loadDatesForm');

const mapStateToProps = (state) => ({
  startDate: loadDatesFormSelector(state, 'startDate'),
  endDate: loadDatesFormSelector(state, 'endDate'),
  expense_filter: loadDatesFormSelector(state, 'expense_filter'),
});

export default connect(mapStateToProps)(ExpenseTickets);
